import { render, staticRenderFns } from "./BloodPressureWithSelfie.vue?vue&type=template&id=3b7d4d1d&lang=pug&"
import script from "./BloodPressureWithSelfie.vue?vue&type=script&lang=js&"
export * from "./BloodPressureWithSelfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports